// Phase 7.1 — Tasks API client.
// Mirrors the shape of `callIntelligence.js`.
import { apiFetch } from './client';

export const tasksApi = {
  list: (params) => apiFetch('/api/tasks', { params }),
  get: (id) => apiFetch(`/api/tasks/${id}`),
  create: (body) => apiFetch('/api/tasks', { method: 'POST', body }),
  update: (id, body) => apiFetch(`/api/tasks/${id}`, { method: 'PATCH', body }),
  complete: (id) =>
    apiFetch(`/api/tasks/${id}/complete`, { method: 'POST', body: {} }),
  dismiss: (id, reason) =>
    apiFetch(`/api/tasks/${id}/dismiss`, {
      method: 'POST',
      body: reason ? { reason } : {},
    }),
};
